"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default = exports.default = {
  name: 'ProductConversion',
  data: function data() {
    return {
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      tableFrom: {
        page: 1,
        limit: 20,
        startTime: '',
        endTime: ''
      },
      timeVal: []
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    // 重置表单
    handleReset: function handleReset() {
      this.tableFrom.startTime = '';
      this.tableFrom.endTime = '';
      this.tableFrom.page = 1;
      this.timeVal = [];
      this.handleSearchList();
    },
    // 搜索列表
    handleSearchList: function handleSearchList() {
      this.tableFrom.page = 1;
      this.getList();
    },
    // 时间选择
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      if (e && e.length === 2) {
        this.tableFrom.startTime = e[0];
        this.tableFrom.endTime = e[1];
      } else {
        this.tableFrom.startTime = '';
        this.tableFrom.endTime = '';
      }
    },
    // 获取列表数据
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _order.productConversionListApi)(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    // 分页改变
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    // 每页数量改变
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 导出Excel
    exports: function exports() {
      var _this2 = this;
      var data = {
        startTime: this.tableFrom.startTime,
        endTime: this.tableFrom.endTime
      };
      (0, _order.productConversionExcelApi)(data).then(function (res) {
        if (res.fileName) {
          window.open(res.fileName);
        } else {
          _this2.$modal.msgSuccess('导出成功');
        }
      }).catch(function () {
        _this2.$modal.msgError('导出失败');
      });
    }
  }
};